"use client";
import { useContext, useState, useEffect } from "react";
import { randomizer } from "@/functions/fns";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Button from "./Button";
import { icons } from "./icons";
import DropDown from "./DropDown";
import { AppContext } from "./AppContext";

export default function Randomizer() {
	const {
		setBg,
		setConfig,
		setOpenLeaf,
		customBg,
		isEditing,
		setHueRotation,
		isSaving,
	} = useContext(AppContext);
	const [exp, setExp] = useState(false);
	const [defs, setDefs] = useState({
		h: [180, 360],
		s: [50, 100],
		l: [50, 100],
	});

	const [refresh, setRefresh] = useState(false);

	const labels = { h: "hue", s: "saturation", l: "luminosity" };

	const [points, setPoints] = useState(5);
	const [steps, setSteps] = useState(2);

	useEffect(() => {
		setRefresh(true);
		setTimeout(() => setRefresh(false), 500);
	}, [steps, points, defs.h, defs.s, defs.l]);

	const extraDetails = [
		{
			name: "Points",
			value: points,
			values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
			onChange: (e) => setPoints(e),
			icon: icons.dots,
		},
		{
			name: "Steps",
			value: steps,
			values: [1, 2, 3, 4],
			onChange: (e) => setSteps(e),
			icon: icons.steps,
		},
	];

	const goRandomize = () => {
		const { bg, ret } = randomizer(defs, points, steps);
		setConfig(ret);
		if (!customBg) setBg(bg);
		setOpenLeaf(null);
		setHueRotation(0);
	};

	useEffect(() => {
		document.body.onkeyup = function (e) {
			if (e.key === " " || e.code === "Space") {
				if (!isEditing && !isSaving) goRandomize();
			}
		};
	}, [isEditing, isSaving]);

	const print = () => {
		const def = [];
		const exp = [];
		Object.keys(defs).forEach((u) => {
			const destination = u === "h" ? def : exp;
			destination.push(
				<div
					className={`slider-box-${u} col-span-2 flex items-center gap-2`}
					key={"def-" + u}
				>
					<div className="miniLabel">{labels[u]}</div>
					<RangeSlider
						min={0}
						max={u === "h" ? 360 : 100}
						value={defs[u]}
						onInput={(e) => setDefs({ ...defs, [u]: e })}
						className="rslider min-w-[200px]"
					/>
				</div>
			);
		});
		extraDetails.forEach((o, i) => {
			const { value, values, name, onChange } = o;
			const destination = exp;

			destination.push(
				<div
					key={"extra-" + i}
					className="flex items-center justify-between gap-2 "
				>
					<div className="miniLabel">{name}</div>
					<DropDown
						/* className="border-color min-w-[60px] border dark:bg-dark-800"
						listClassName="bg-white dark:ring-0 dark:bg-dark-800 -mt-[4px]" */
						value={value}
						values={values}
						onChange={onChange}
					/>
				</div>
			);
		});
		return { def, exp };
	};

	const animBg =
		steps > 1 ? "bg-dark-800 dark:bg-accent-600" : "dark:bg-dark-900";

	return (
		<>
			{print().def}
			<div className="flex items-center gap-3">
				<div className="miniLabel">Animated</div>

				<div
					onClick={() => {
						setSteps((s) => (s === 1 ? 2 : 1));
					}}
					className={
						animBg +
						" h-2 w-2  cursor-pointer rounded-sm ring-1 ring-dark-200 ring-offset-2 dark:h-3 dark:w-3 dark:border-2 dark:border-dark-800 dark:ring-dark-700 dark:ring-offset-0"
					}
				/>
			</div>
			<div
				className={
					exp
						? "relative "
						: "relative rounded hover:bg-dark-50 dark:hover:bg-dark-700"
				}
			>
				{exp && (
					<div className=" absolute bottom-full left-1/2 -ml-[150px] mb-6 grid w-[300px] grid-cols-2 gap-2 rounded-lg bg-white p-3 ring-1 ring-dark-900/5 dark:bg-dark-900">
						<div
							onClick={() => setExp(false)}
							className="wu hu flexer absolute bottom-full left-full cursor-pointer rounded-full bg-white text-dark-900 opacity-50 dark:bg-dark-900 dark:text-white"
						>
							{icons.close}
						</div>
						{print().exp}
					</div>
				)}
				<div className="barButton" onClick={() => setExp((e) => !e)}>
					{icons[exp ? "close" : "steps"]}
				</div>
			</div>
			<Button
				className="bg-dark-800 px-3 text-white transition-colors hover:bg-dark-700 dark:bg-dark-600 dark:text-dark-200 dark:hover:bg-dark-500"
				onClick={goRandomize}
			>
				<div className={refresh ? "animate-spin duration-75" : ""}>
					{icons.randomize}
				</div>
				Generate
			</Button>
		</>
	);
}
